import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { useCreateDriver, useUpdateDriver } from "../apis";
import { DriverFormValues } from "../components";
import {
  convertFormDataToCreateRequestBody,
  convertFormDataToUpdateRequestBody
} from "../helpers";
import useDriversBasePath from "./useDriversBasePath";

const useDriverDetailsFormSubmit = (editableDriver: DriverFormValues) => {
  const navigate = useNavigate();
  const basePath = useDriversBasePath();
  const { t } = useTranslation();
  const { editableDriverId } = useParams();

  const { isLoading: isLoadingCreateDriver, mutate: mutateCreateDriver } =
    useCreateDriver({
      onSuccess: () => {
        navigate(basePath);
        toast.success(t("Driver was created successfully"));
      }
    });

  const { isLoading: isLoadingUpdateDriver, mutate: mutateUpdateDriver } =
    useUpdateDriver({
      onSuccess: () => {
        navigate(basePath);
        toast.success(t("Driver was updated successfully"));
      }
    });

  const onSubmit = (formData: DriverFormValues) => {
    if (!editableDriverId) {
      const body = convertFormDataToCreateRequestBody(formData);
      mutateCreateDriver(body);
    } else if (editableDriverId) {
      const body = convertFormDataToUpdateRequestBody(editableDriver, formData);
      mutateUpdateDriver(body);
    }
  };

  return {
    onSubmit,
    isSubmitLoading: isLoadingCreateDriver || isLoadingUpdateDriver
  };
};

export default useDriverDetailsFormSubmit;
